import React, { forwardRef } from 'react';
import Text from '../../atoms/text/Text';
import {
  FileUpload,
  FileUploadProps,
} from '../../atoms/file-upload/FileUpload';
import ErrorMessage, {
  Errors,
  getStatus,
} from '../../atoms/message/ErrorMessage';

interface InputFileUploadProps extends FileUploadProps {
  title?: string;
  subtitle?: string;
  getTranslation?: (message: string) => string;
  error?: Errors;
}

// eslint-disable-next-line react/display-name
const InputFileUpload = forwardRef<HTMLInputElement, InputFileUploadProps>(
  (
    {
      title,
      subtitle,
      error,
      name,
      status,
      fileTypesText,
      maxSizeText,
      jpgFileFormatIcon,
      onDragOver,
      onDrop,
      onChange,
      getTranslation,
      ...props
    }: InputFileUploadProps,
    ref,
  ) => {
    return (
      <div className="d-flex flex-column gap-4">
        {title && (
          <Text color="title" weight="semibold" size="sm">
            {title}
          </Text>
        )}
        {subtitle && (
          <Text color="subtitle1" size="sm">
            {subtitle}
          </Text>
        )}
        <FileUpload
          ref={ref}
          {...props}
          name={name}
          status={getStatus(error, name, status)}
          fileTypesText={fileTypesText}
          maxSizeText={maxSizeText}
          jpgFileFormatIcon={jpgFileFormatIcon}
          onDragOver={onDragOver}
          onDrop={onDrop}
          onChange={onChange}
        />

        <ErrorMessage
          name={name}
          errors={error}
          getTranslation={getTranslation}
        />
      </div>
    );
  },
);

export default InputFileUpload;
